import AbstractPage from './abstract-page';
import {createRef} from 'preact';


export default class SingleChoice extends AbstractPage {
  constructor(props) {
    super(props);
  }

  gameScreen = createRef();

  componentDidMount() {
    if (this.gameScreen.current.scrollHeight && document.documentElement.clientWidth < 730) {
      document.querySelector('.footer').style.marginTop = `${this.gameScreen.current.scrollHeight}px`;
    }
  }

  render() {
    const question = this.screenData;
    const mainHeader = (this.props.data.title) ? <h1 className="content__game-title">{this.props.data.title}</h1> : '';
    const subHeader = (this.props.data.description) ? <span>{this.props.data.description}</span> : '';
    const questionCounter = (this.progress) ? Array(this.progress.numberOfQuestion).fill().map((element, i) => (i <= this.progress.questionNumber - 1) ? <span className="content__counter-bar content__counter-bar_passed" key={i}></span> : <span className="content__counter-bar" key={i}></span>) : '';
    const questionTitle = (question.title) ? <h3>{question.title}</h3> : '';
    const questionDescription = (question.description) ? <div className="content__main-text" dangerouslySetInnerHTML={{__html: question.description}} /> : '';
    const listOptions = question.answers.map((answer) => <li className="content__question-list-item"><button className="content__question-item" type="button" onClick={() => this.onNext([answer.next])}>{answer.title}</button></li>);
    const reference = (question.ref) ? (question.ref) : '#';
    return (
      <article ref={this.gameScreen} className={question.specialClass}>
        {mainHeader}
        {subHeader}
        <div className="content__counter">
          {questionCounter}
        </div>
        {questionTitle}
        {questionDescription}
        <ul className="content__question-list">
          {listOptions}
        </ul>
      </article>
    );
  }

  static backDataToModel(step) {
    const result = AbstractPage.backDataToModel(step);
    result.isMultiple = false;
    result.answers = [];
    for (let answer of step.answers) {
      let resultAnswer = {};
      resultAnswer.title = (answer.title) ? answer.title : null;
      resultAnswer.next = (answer.next) ? answer.next : null;
      result.answers.push(resultAnswer);
    }
    return result;
  }
}



// WEBPACK FOOTER //
// ./components/page/view/single-choice.js